<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">Data Dukung</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            Asesmen Lapangan Akreditasi
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12" style="overflow:auto">
          <table border="0" cellpadding="0" cellspacing="0" id="sheet0" class="sheet0 gridlines">
            <col class="col0">
            <col class="col1">
            <col class="col2">
            <col class="col3">
            <col class="col4">
            <col class="col5">
            <tbody>
              <tr class="row0">
                <td class="column0 style1 s">No</td>
                <td class="column1 style1 s">Elemen</td>
                <td class="column2 style1 s">Data Dukung</td>
                <td class="column3 style1 s">Status</td>
                <td class="column4 style1 s">Catatan</td>
                <td class="column5 style1 s">Link</td>
              </tr>
              <tr class="row1">
                <td class="column0 style2 n">1</td>
                <td class="column1 style3 s">A. Kondisi Eksternal</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row2">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Renstra PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Renstra 2020-2024</td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing" title="">https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing</a></td>
              </tr>
              <tr class="row3">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">RKAT PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row4">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Renop PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row5">
                <td class="column0 style2 n">2</td>
                <td class="column1 style3 s">B. Profil Unit Pengelola institusi</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row6">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana Pengembangan Institusi</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">RIP 2011-2025 belumada 20 tahun ke depan</td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing" title="">https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing</a></td>
              </tr>
              <tr class="row7">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku/video profil PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Video profil PNB Tahun 2021</td>
                <td class="column5 style4 s"><a href="https://www.youtube.com/watch?v=dS7DMGEYi4U&amp;t=189s" title="">https://www.youtube.com/watch?v=dS7DMGEYi4U&amp;t=189s</a></td>
              </tr>
              <tr class="row8">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK pendirian PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row9">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Statuta PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row10">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">LAKIN 2019, 2020, 2021</td>
                <td class="column5 style4 s"><a href="https://pnb.ac.id/news/detail?berita=40" title="">https://pnb.ac.id/news/detail?berita=40</a></td>
              </tr>
              <tr class="row11">
                <td class="column0 style2 n">3</td>
                <td class="column1 style3 s">C. Kriteria</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row12">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.1. Visi, Misi, Tujuan dan Strategi</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row13">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.1.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row14">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra PNB jangka pendek</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Rencana Kerja Tahunan (RKT) 2022, RENOP</td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1iYsGXvrEZsWdyV1yV4uw9FtmeKCVDJ6y/view?usp=sharing" title="">https://drive.google.com/file/d/1iYsGXvrEZsWdyV1yV4uw9FtmeKCVDJ6y/view?usp=sharing</a></td>
              </tr>
              <tr class="row15">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra PNB jangka menengah</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Renstra 2020-2024</td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing" title="">https://drive.google.com/file/d/1MnueG_p81AN24at5u1EHC5N7YtOMmXNf/view?usp=sharing</a></td>
              </tr>
              <tr class="row16">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra PNB jangka panjang</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Belum ada RIP PNB 2025-2045, tersedia dokumen RIP 2011-2025</td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1mt743hMro7eb-58n75hK2gauxf4rwGWb/view?usp=sharing" title="">https://drive.google.com/file/d/1mt743hMro7eb-58n75hK2gauxf4rwGWb/view?usp=sharing</a></td>
              </tr>
              <tr class="row17">
                <td class="column0 style2 n">4</td>
                <td class="column1 style3 s">C.2. Tata Pamong, Tata Kelola dan Kerjasama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row18">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.2.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row19">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.2.4.a) Sistem Tata Pamong</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row20">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Dokumen tata pamong institusi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing" title="">https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing</a></td>
              </tr>
              <tr class="row21">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1BckAFEDiaNFQd_pxd_rMMXzumi2J1x_R/view?usp=sharing" title="">https://drive.google.com/file/d/1BckAFEDiaNFQd_pxd_rMMXzumi2J1x_R/view?usp=sharing</a></td>
              </tr>
              <tr class="row22">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1RlPRKNrhXVAA1lyQzXjl-DTxbn-1hPLh/view?usp=sharing" title="">https://drive.google.com/file/d/1RlPRKNrhXVAA1lyQzXjl-DTxbn-1hPLh/view?usp=sharing</a></td>
              </tr>
              <tr class="row23">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/18DjKCbg4VWag2_HIs6W9GRuDq5a-KJL8/view?usp=sharing" title="">https://drive.google.com/file/d/18DjKCbg4VWag2_HIs6W9GRuDq5a-KJL8/view?usp=sharing</a></td>
              </tr>
              <tr class="row24">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing" title="">https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing</a></td>
              </tr>
              <tr class="row25">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing" title="">https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing</a></td>
              </tr>
              <tr class="row26">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1umQzdbq8TK-a0Vrkcun0mb2Zio633XC2/view?usp=sharing" title="">https://drive.google.com/file/d/1umQzdbq8TK-a0Vrkcun0mb2Zio633XC2/view?usp=sharing</a></td>
              </tr>
              <tr class="row27">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1GBJ43bUOVeMyRxgfIwkSbjgXbvaFyqPl/view?usp=sharing" title="">https://drive.google.com/file/d/1GBJ43bUOVeMyRxgfIwkSbjgXbvaFyqPl/view?usp=sharing</a></td>
              </tr>
              <tr class="row28">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1g7tu-El9kdYQrGp-6xMskrF0aKpMXO0N/view?usp=sharing" title="">https://drive.google.com/file/d/1g7tu-El9kdYQrGp-6xMskrF0aKpMXO0N/view?usp=sharing</a></td>
              </tr>
              <tr class="row29">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1Vc4Tk4yzRQuOjFFExFbhr5Nv5uNfimSx/view?usp=sharing" title="">https://drive.google.com/file/d/1Vc4Tk4yzRQuOjFFExFbhr5Nv5uNfimSx/view?usp=sharing</a></td>
              </tr>
              <tr class="row30">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1nqNUUSqe5NgecjAQrVFBbziMcuheKizl/view?usp=sharing" title="">https://drive.google.com/file/d/1nqNUUSqe5NgecjAQrVFBbziMcuheKizl/view?usp=sharing</a></td>
              </tr>
              <tr class="row31">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1S9Rm-SUMNapqV-i_SG59vkEoc-770ywj/view?usp=sharing" title="">https://drive.google.com/file/d/1S9Rm-SUMNapqV-i_SG59vkEoc-770ywj/view?usp=sharing</a></td>
              </tr>
              <tr class="row32">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1P1jlK3O6rBv9lNYSfXTX8nlD6Lbn5K67/view?usp=sharing" title="">https://drive.google.com/file/d/1P1jlK3O6rBv9lNYSfXTX8nlD6Lbn5K67/view?usp=sharing</a></td>
              </tr>
              <tr class="row33">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1T3HTe5obZ_ASrKGdC-cY-V9mvXSEp4Co/view?usp=sharing" title="">https://drive.google.com/file/d/1T3HTe5obZ_ASrKGdC-cY-V9mvXSEp4Co/view?usp=sharing</a></td>
              </tr>
              <tr class="row34">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1GldPg0XTjf8YvVTe8ybuYc3jKVZ1DF0K/view?usp=sharing" title="">https://drive.google.com/file/d/1GldPg0XTjf8YvVTe8ybuYc3jKVZ1DF0K/view?usp=sharing</a></td>
              </tr>
              <tr class="row35">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1GGF2psb7YhxK2MVcYvcxUz2cO6F70H0p/view?usp=sharing" title="">https://drive.google.com/file/d/1GGF2psb7YhxK2MVcYvcxUz2cO6F70H0p/view?usp=sharing</a></td>
              </tr>
              <tr class="row36">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing" title="">https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing</a></td>
              </tr>
              <tr class="row37">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/17daBWoaVjjW6JI1tMopvrliMYpJLCtSd/view?usp=sharing" title="">https://drive.google.com/file/d/17daBWoaVjjW6JI1tMopvrliMYpJLCtSd/view?usp=sharing</a></td>
              </tr>
              <tr class="row38">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1CcbUoBnxMG4ZSgEqkesMHuxm0wDkem10/view?usp=sharing" title="">https://drive.google.com/file/d/1CcbUoBnxMG4ZSgEqkesMHuxm0wDkem10/view?usp=sharing</a></td>
              </tr>
              <tr class="row39">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing" title="">https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing</a></td>
              </tr>
              <tr class="row40">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1abKToHPGBRxzdZ24rqQW6h4xJGaOcoPK/view?usp=sharing" title="">https://drive.google.com/file/d/1abKToHPGBRxzdZ24rqQW6h4xJGaOcoPK/view?usp=sharing</a></td>
              </tr>
              <tr class="row41">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1PveReVWbFswhNmrDfli_VW1HA9Zb5w49/view?usp=sharing" title="">https://drive.google.com/file/d/1PveReVWbFswhNmrDfli_VW1HA9Zb5w49/view?usp=sharing</a></td>
              </tr>
              <tr class="row42">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1XIqIxq85SooMQ7Qj0_MiJF3ZA3RxJpQ1/view?usp=sharing" title="">https://drive.google.com/file/d/1XIqIxq85SooMQ7Qj0_MiJF3ZA3RxJpQ1/view?usp=sharing</a></td>
              </tr>
              <tr class="row43">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/18hLiY20OJ4s9vRRmq6US0vXTrrHMkwnv/view?usp=sharing" title="">https://drive.google.com/file/d/18hLiY20OJ4s9vRRmq6US0vXTrrHMkwnv/view?usp=sharing</a></td>
              </tr>
              <tr class="row44">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1g_mKMkqq7CKPvSwufMy-otxc4FaiLH-l/view?usp=sharing" title="">https://drive.google.com/file/d/1g_mKMkqq7CKPvSwufMy-otxc4FaiLH-l/view?usp=sharing</a></td>
              </tr>
              <tr class="row45">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/15VpFZlJk8UwW1GFTu393IKlgmbnoDKgG/view?usp=sharing" title="">https://drive.google.com/file/d/15VpFZlJk8UwW1GFTu393IKlgmbnoDKgG/view?usp=sharing</a></td>
              </tr>
              <tr class="row46">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1ku_vBKljHUukSASOUZCaNccajEe3MRwz/view?usp=sharing" title="">https://drive.google.com/file/d/1ku_vBKljHUukSASOUZCaNccajEe3MRwz/view?usp=sharing</a></td>
              </tr>
              <tr class="row47">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/10Csk_uJna6s9-WT6JJmrX7wp8KQYwvB0/view?usp=sharing" title="">https://drive.google.com/file/d/10Csk_uJna6s9-WT6JJmrX7wp8KQYwvB0/view?usp=sharing</a></td>
              </tr>
              <tr class="row48">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/18YBYQF2wxg88GKluh_yiH-yPH0EOHNRz/view?usp=sharing" title="">https://drive.google.com/file/d/18YBYQF2wxg88GKluh_yiH-yPH0EOHNRz/view?usp=sharing</a></td>
              </tr>
              <tr class="row49">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1k5Fsd1y_otMUzXJSuU5cO0peBOr9RS9J/view?usp=sharing" title="">https://drive.google.com/file/d/1k5Fsd1y_otMUzXJSuU5cO0peBOr9RS9J/view?usp=sharing</a></td>
              </tr>
              <tr class="row50">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1abKToHPGBRxzdZ24rqQW6h4xJGaOcoPK/view?usp=sharing" title="">https://drive.google.com/file/d/1abKToHPGBRxzdZ24rqQW6h4xJGaOcoPK/view?usp=sharing</a></td>
              </tr>
              <tr class="row51">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1XIqIxq85SooMQ7Qj0_MiJF3ZA3RxJpQ1/view?usp=sharing" title="">https://drive.google.com/file/d/1XIqIxq85SooMQ7Qj0_MiJF3ZA3RxJpQ1/view?usp=sharing</a></td>
              </tr>
              <tr class="row52">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1VmoW-ZIcvKnqjmE1GgVGUrzV6DnxRBYj/view?usp=sharing" title="">https://drive.google.com/file/d/1VmoW-ZIcvKnqjmE1GgVGUrzV6DnxRBYj/view?usp=sharing</a></td>
              </tr>
              <tr class="row53">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1bgDiKO3qNKb9jPQGs-SurFo_CWV-XqRb/view?usp=sharing" title="">https://drive.google.com/file/d/1bgDiKO3qNKb9jPQGs-SurFo_CWV-XqRb/view?usp=sharing</a></td>
              </tr>
              <tr class="row54">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/1Aw4k0ptEyPIGCNiApl9VkaOijTrQxqE2?usp=sharing" title="">https://drive.google.com/drive/folders/1Aw4k0ptEyPIGCNiApl9VkaOijTrQxqE2?usp=sharing</a></td>
              </tr>
              <tr class="row55">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing" title="">https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing</a></td>
              </tr>
              <tr class="row56">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing" title="">https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing</a></td>
              </tr>
              <tr class="row57">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing" title="">https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing</a></td>
              </tr>
              <tr class="row58">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing" title="">https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing</a></td>
              </tr>
              <tr class="row59">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/17lTEZ9DNwf_ldLmueyDitxz1aqOswwGe?usp=sharing" title="">https://drive.google.com/drive/folders/17lTEZ9DNwf_ldLmueyDitxz1aqOswwGe?usp=sharing</a></td>
              </tr>
              <tr class="row60">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://docs.google.com/document/d/1gsPYeJTXZFYbVs44FBArvssus6bHyUAW/edit?usp=sharing&amp;ouid=103461232949968322349&amp;rtpof=true&amp;sd=true" title="">https://docs.google.com/document/d/1gsPYeJTXZFYbVs44FBArvssus6bHyUAW/edit?usp=sharing&amp;ouid=103461232949968322349&amp;rtpof=true&amp;sd=true</a></td>
              </tr>
              <tr class="row61">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/1Xr6NzXrhomnBdl11GEKqwrsaUbvjGQ63?usp=sharing" title="">https://drive.google.com/drive/folders/1Xr6NzXrhomnBdl11GEKqwrsaUbvjGQ63?usp=sharing</a></td>
              </tr>
              <tr class="row62">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing" title="">https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing</a></td>
              </tr>
              <tr class="row63">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/1KIV5FiroYE4SnIAX84i0SIC7LTabtuWi?usp=sharing" title="">https://drive.google.com/drive/folders/1KIV5FiroYE4SnIAX84i0SIC7LTabtuWi?usp=sharing</a></td>
              </tr>
              <tr class="row64">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/1JaD0c9hFWrNqrrbrj44qalHIDk1kK2us?usp=sharing" title="">https://drive.google.com/drive/folders/1JaD0c9hFWrNqrrbrj44qalHIDk1kK2us?usp=sharing</a></td>
              </tr>
              <tr class="row65">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK Direktur tentang perlindungan integritas akademik dan kualitas PT</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1p4Vc1gVRm7S7nQ41URojis9TEe0jqKJe/view?usp=sharing" title="">https://drive.google.com/file/d/1p4Vc1gVRm7S7nQ41URojis9TEe0jqKJe/view?usp=sharing</a></td>
              </tr>
              <tr class="row66">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1nyyVeFQhOZEJQ9JL_CQOJnSODyydRBoY/view?usp=sharing" title="">https://drive.google.com/file/d/1nyyVeFQhOZEJQ9JL_CQOJnSODyydRBoY/view?usp=sharing</a></td>
              </tr>
              <tr class="row67">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1X-TNcoII4txqqr3AsaqPWBdE-huVIbcU/view?usp=sharing" title="">https://drive.google.com/file/d/1X-TNcoII4txqqr3AsaqPWBdE-huVIbcU/view?usp=sharing</a></td>
              </tr>
              <tr class="row68">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1EUMSwCyEcDMkrncopG-9NcZ-1QpLDzoa/view?usp=sharing" title="">https://drive.google.com/file/d/1EUMSwCyEcDMkrncopG-9NcZ-1QpLDzoa/view?usp=sharing</a></td>
              </tr>
              <tr class="row69">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing" title="">https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing</a></td>
              </tr>
              <tr class="row70">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1S9Rm-SUMNapqV-i_SG59vkEoc-770ywj/view?usp=sharing" title="">https://drive.google.com/file/d/1S9Rm-SUMNapqV-i_SG59vkEoc-770ywj/view?usp=sharing</a></td>
              </tr>
              <tr class="row71">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1L9YK7_6pckkpG4TOqX5EAwj6VH0X0o12/view?usp=sharing" title="">https://drive.google.com/file/d/1L9YK7_6pckkpG4TOqX5EAwj6VH0X0o12/view?usp=sharing</a></td>
              </tr>
              <tr class="row72">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1q2ZRSRlTZWq3Ent1MUWzyubFcrsav7Ud/view?usp=sharing" title="">https://drive.google.com/file/d/1q2ZRSRlTZWq3Ent1MUWzyubFcrsav7Ud/view?usp=sharing</a></td>
              </tr>
              <tr class="row73">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1_1zsLyblul3nzZgr4qx3z8fvq1S0S_wd/view?usp=sharing" title="">https://drive.google.com/file/d/1_1zsLyblul3nzZgr4qx3z8fvq1S0S_wd/view?usp=sharing</a></td>
              </tr>
              <tr class="row74">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing" title="">https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing</a></td>
              </tr>
              <tr class="row75">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti dokumen formal struktur organisasi dilengkapi tugas dan fungsi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1K0GlshWxywfdIic7N8Qr6Tezv4alq6FS/view?usp=sharing" title="">https://drive.google.com/file/d/1K0GlshWxywfdIic7N8Qr6Tezv4alq6FS/view?usp=sharing</a></td>
              </tr>
              <tr class="row76">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing" title="">https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing</a></td>
              </tr>
              <tr class="row77">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing%20" title="">https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing </a></td>
              </tr>
              <tr class="row78">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/1UoYEGwuZlJXi27CrkAUiGC6PItoL42Ex?usp=sharing" title="">https://drive.google.com/drive/folders/1UoYEGwuZlJXi27CrkAUiGC6PItoL42Ex?usp=sharing</a></td>
              </tr>
              <tr class="row79">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti pedoman dan prosedur pelayanan (SOP/POS)</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1fNicSiKfwzSxnKzNInojYUQR6JG7UxAT?usp=sharing" title="">https://drive.google.com/drive/folders/1fNicSiKfwzSxnKzNInojYUQR6JG7UxAT?usp=sharing </a></td>
              </tr>
              <tr class="row80">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Ketersediaan LAKIP PNB di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1Z8kvMzSCfuoqb1nbIpC5oavwLuaXeCt5/view?usp=sharing" title="">https://drive.google.com/file/d/1Z8kvMzSCfuoqb1nbIpC5oavwLuaXeCt5/view?usp=sharing </a></td>
              </tr>
              <tr class="row81">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Dokumen TKO PNB (terdapat komisi etik)</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row82">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK Tim komisi etik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row83">
                <td class="column0 style2 n">5</td>
                <td class="column1 style3 s">C.2.4.b) Kepemimpinan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row84">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti  Rencana Kerja Anggaran (RKA)</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row85">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK direktur dan wakil direktur</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row86">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK kajur dan sekjur</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row87">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK kepala pusat, unit, dan UPT</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row88">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK kabag dan kasubag</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row89">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Notulensi dan daftar hadir rapat pimpinan rutin PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row90">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row91">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP 6 Jurusan di bawah PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row92">
                <td class="column0 style2 n">6</td>
                <td class="column1 style3 s">C.2.4.c) Pengelolaan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row93">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">RKAT PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">1. Perencanaan</td>
              </tr>
              <tr class="row94">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing" title="">https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing </a></td>
              </tr>
              <tr class="row95">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing" title="">https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing</a></td>
              </tr>
              <tr class="row96">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1QF-d4rrLp_R3XbfixMIens-w3uVN5Uw4/view?usp=sharing" title="">https://drive.google.com/file/d/1QF-d4rrLp_R3XbfixMIens-w3uVN5Uw4/view?usp=sharing </a></td>
              </tr>
              <tr class="row97">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1llOtHbMvnufJpHJdtlfU_b9ff7JV_RvS/view?usp=sharing" title="">https://drive.google.com/file/d/1llOtHbMvnufJpHJdtlfU_b9ff7JV_RvS/view?usp=sharing </a></td>
              </tr>
              <tr class="row98">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1LoA_UQ-A5_W7cWAb-lqlni6hujcB4FYl/view?usp=sharing" title="">https://drive.google.com/file/d/1LoA_UQ-A5_W7cWAb-lqlni6hujcB4FYl/view?usp=sharing </a></td>
              </tr>
              <tr class="row99">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing" title="">https://drive.google.com/drive/folders/19dWj6w2rZSz-hDunZp8ZlEKlq66GvbeH?usp=sharing</a></td>
              </tr>
              <tr class="row100">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1EFLMJ5aNfq5NADzhQuFSTlTYQrmJ_Ckv/view?usp=sharing" title="">https://drive.google.com/file/d/1EFLMJ5aNfq5NADzhQuFSTlTYQrmJ_Ckv/view?usp=sharing</a></td>
              </tr>
              <tr class="row101">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/19vKs4S0IpXV0XUqNOnnWr_wLUy3Dyw1_/view?usp=sharing" title="">https://drive.google.com/file/d/19vKs4S0IpXV0XUqNOnnWr_wLUy3Dyw1_/view?usp=sharing</a></td>
              </tr>
              <tr class="row102">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1RHCoBSTEa6rMkJ-mbsMs1f8-O4iykSd9/view?usp=sharing" title="">https://drive.google.com/file/d/1RHCoBSTEa6rMkJ-mbsMs1f8-O4iykSd9/view?usp=sharing</a></td>
              </tr>
              <tr class="row103">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">2. Pengorganisasian:</td>
              </tr>
              <tr class="row104">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing" title="">https://drive.google.com/file/d/1NkoGk66hPbNHBLklvcTijM2WvJJEAxhG/view?usp=sharing</a></td>
              </tr>
              <tr class="row105">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1q2ZRSRlTZWq3Ent1MUWzyubFcrsav7Ud/view?usp=sharing" title="">https://drive.google.com/file/d/1q2ZRSRlTZWq3Ent1MUWzyubFcrsav7Ud/view?usp=sharing</a></td>
              </tr>
              <tr class="row106">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/14pbh0_BnzcPK9P4OlrPl1o1kW0l4wp0D/view?usp=sharing" title="">https://drive.google.com/file/d/14pbh0_BnzcPK9P4OlrPl1o1kW0l4wp0D/view?usp=sharing</a></td>
              </tr>
              <tr class="row107">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1wft30alc6GDMDhtgESDqB_Wqctw-rOuu/view?usp=sharing" title="">https://drive.google.com/file/d/1wft30alc6GDMDhtgESDqB_Wqctw-rOuu/view?usp=sharing</a></td>
              </tr>
              <tr class="row108">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1jQS1KCBlbGYmNWGUUhEyBymATEkP3cyK/view?usp=sharing" title="">https://drive.google.com/file/d/1jQS1KCBlbGYmNWGUUhEyBymATEkP3cyK/view?usp=sharing</a></td>
              </tr>
              <tr class="row109">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">3. Penempatan Personil:</td>
              </tr>
              <tr class="row110">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1OdCp6WOycgdAL6yLlsjQ2K9nZywy7_jt/view?usp=sharing" title="">https://drive.google.com/file/d/1OdCp6WOycgdAL6yLlsjQ2K9nZywy7_jt/view?usp=sharing</a></td>
              </tr>
              <tr class="row111">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing" title="">https://drive.google.com/file/d/19FwcmhkITJXTqcWracQJb0Mi9-G79aKt/view?usp=sharing</a></td>
              </tr>
              <tr class="row112">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">4. Pengarahan:</td>
              </tr>
              <tr class="row113">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1gdapNkRniyd1BclaCI6ZXXLd9UntKGxP/view?usp=sharing" title="">https://drive.google.com/file/d/1gdapNkRniyd1BclaCI6ZXXLd9UntKGxP/view?usp=sharing </a></td>
              </tr>
              <tr class="row114">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">5. Pengawasan:</td>
              </tr>
              <tr class="row115">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1HGRp7bwBoTv38-L5PHMCjAgyfmhg2Kds/view?usp=sharing" title="">https://drive.google.com/file/d/1HGRp7bwBoTv38-L5PHMCjAgyfmhg2Kds/view?usp=sharing</a></td>
              </tr>
              <tr class="row116">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1hVza_t_y3ied6RDjuPVmxY7fcZ1-xewP/view?usp=sharing" title="">https://drive.google.com/file/d/1hVza_t_y3ied6RDjuPVmxY7fcZ1-xewP/view?usp=sharing</a></td>
              </tr>
              <tr class="row117">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1kFcA2ZCY5rE4rUnF2FOH5Yv7OnMmaukr/view?usp=sharing" title="">https://drive.google.com/file/d/1kFcA2ZCY5rE4rUnF2FOH5Yv7OnMmaukr/view?usp=sharing</a></td>
              </tr>
              <tr class="row118">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing" title="">https://drive.google.com/file/d/14OpgyWQO9PLuXH7hOofYY8pl5rIYxQ8q/view?usp=sharing</a></td>
              </tr>
              <tr class="row119">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style6 null"></td>
              </tr>
              <tr class="row120">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan pendidikan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1c9oiS3AZGoiLDpvm-z7dLZhYiLbW0HvA?usp=sharing" title="">https://drive.google.com/drive/folders/1c9oiS3AZGoiLDpvm-z7dLZhYiLbW0HvA?usp=sharing</a></td>
              </tr>
              <tr class="row121">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan pengembangan suasana akademik dan otonomi keilmuan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row122">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan kemahasiswaan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing" title="">https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing</a></td>
              </tr>
              <tr class="row123">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan penelitian</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1QjYbFCtHHEUJvpWjvLv8Y_KRYptm2E74/view?usp=sharing" title="">https://drive.google.com/file/d/1QjYbFCtHHEUJvpWjvLv8Y_KRYptm2E74/view?usp=sharing</a></td>
              </tr>
              <tr class="row124">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan PkM</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1wMwddivIG2q7LQ_XZUZHT0KlhEkh0JyZ/view?usp=sharing" title="">https://drive.google.com/file/d/1wMwddivIG2q7LQ_XZUZHT0KlhEkh0JyZ/view?usp=sharing</a></td>
              </tr>
              <tr class="row125">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan SDM</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1n7_GnaYcYUGkedmALpbD89jqApTq-s8r?usp=sharing" title="">https://drive.google.com/drive/folders/1n7_GnaYcYUGkedmALpbD89jqApTq-s8r?usp=sharing</a></td>
              </tr>
              <tr class="row126">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan keuangan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1qitYeQgm9-UCN8ogTGkJgPoxGFCwO8FK?usp=sharing" title="">https://drive.google.com/drive/folders/1qitYeQgm9-UCN8ogTGkJgPoxGFCwO8FK?usp=sharing</a></td>
              </tr>
              <tr class="row127">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan sarana dan prasarana</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing" title="">https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing</a></td>
              </tr>
              <tr class="row128">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan sistem informasi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row129">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan sistem penjaminan mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing" title="">https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing</a></td>
              </tr>
              <tr class="row130">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman pengelolaan kerjasama</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1Sy6mni-iog12jXSnpx7wtL_5wa0F25YE?usp=sharing" title="">https://drive.google.com/drive/folders/1Sy6mni-iog12jXSnpx7wtL_5wa0F25YE?usp=sharing</a></td>
              </tr>
              <tr class="row131">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row132">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi pendidikan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1eeYTbDEo7dzi2erk5pyg8Tp-B8E2VrvD/view?usp=sharing" title="">https://drive.google.com/file/d/1eeYTbDEo7dzi2erk5pyg8Tp-B8E2VrvD/view?usp=sharing</a></td>
              </tr>
              <tr class="row133">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing" title="">https://drive.google.com/file/d/1S8oZurnI0Qr-Zwyp-LZIDz337UqmmDWM/view?usp=sharing</a></td>
              </tr>
              <tr class="row134">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing" title="">https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing</a></td>
              </tr>
              <tr class="row135">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing" title="">https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing</a></td>
              </tr>
              <tr class="row136">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1wpsaxg02Kno9X8L8KdK5ChE6iP-CvD0I?usp=sharing" title="">https://drive.google.com/drive/folders/1wpsaxg02Kno9X8L8KdK5ChE6iP-CvD0I?usp=sharing</a></td>
              </tr>
              <tr class="row137">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1TBBLhn2AhLCvCIix-cBXUgUTBD-esQ4g?usp=sharing" title="">https://drive.google.com/drive/folders/1TBBLhn2AhLCvCIix-cBXUgUTBD-esQ4g?usp=sharing</a></td>
              </tr>
              <tr class="row138">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/10Bm9VVs4o9hEXIbYqkgw1QGABDWKHHr5?usp=sharing" title="">https://drive.google.com/drive/folders/10Bm9VVs4o9hEXIbYqkgw1QGABDWKHHr5?usp=sharing</a></td>
              </tr>
              <tr class="row139">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://sion.pnb.ac.id/" title="">https://sion.pnb.ac.id/</a></td>
              </tr>
              <tr class="row140">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row141">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi  pengembangan suasana akademik dan otonomi keilmuan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing" title="">https://drive.google.com/file/d/1_GcYQS0u0yzBjqwstYAfPO6Fwara1nap/view?usp=sharing</a></td>
              </tr>
              <tr class="row142">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/10wl_NBdRMlUJacO5v2JL9qbDJW53RXyG/view?usp=sharing" title="">https://drive.google.com/file/d/10wl_NBdRMlUJacO5v2JL9qbDJW53RXyG/view?usp=sharing</a></td>
              </tr>
              <tr class="row143">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row144">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi  kemahasiswaan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1C7_k6Ot2wg_9hLJBV4ZNIih2VUGm73ww/view?usp=sharing" title="">https://drive.google.com/file/d/1C7_k6Ot2wg_9hLJBV4ZNIih2VUGm73ww/view?usp=sharing</a></td>
              </tr>
              <tr class="row145">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://docs.google.com/spreadsheets/d/18wkMS3M78V-FseNTX7k9D_SXjjxReLoY/edit?usp=sharing&amp;ouid=103461232949968322349&amp;rtpof=true&amp;sd=true" title="">https://docs.google.com/spreadsheets/d/18wkMS3M78V-FseNTX7k9D_SXjjxReLoY/edit?usp=sharing&amp;ouid=103461232949968322349&amp;rtpof=true&amp;sd=true</a></td>
              </tr>
              <tr class="row146">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1_1zsLyblul3nzZgr4qx3z8fvq1S0S_wd/view?usp=sharing" title="">https://drive.google.com/file/d/1_1zsLyblul3nzZgr4qx3z8fvq1S0S_wd/view?usp=sharing</a></td>
              </tr>
              <tr class="row147">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row148">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi  penelitian</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1wMwddivIG2q7LQ_XZUZHT0KlhEkh0JyZ/view?usp=sharing" title="">https://drive.google.com/file/d/1wMwddivIG2q7LQ_XZUZHT0KlhEkh0JyZ/view?usp=sharing</a></td>
              </tr>
              <tr class="row149">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="http://www.simlitabmas.pnb.ac.id/" title="">http://www.simlitabmas.pnb.ac.id/</a></td>
              </tr>
              <tr class="row150">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row151">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi PkM</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1QjYbFCtHHEUJvpWjvLv8Y_KRYptm2E74/view?usp=sharing" title="">https://drive.google.com/file/d/1QjYbFCtHHEUJvpWjvLv8Y_KRYptm2E74/view?usp=sharing</a></td>
              </tr>
              <tr class="row152">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi  SDM</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1n7_GnaYcYUGkedmALpbD89jqApTq-s8r?usp=sharing" title="">https://drive.google.com/drive/folders/1n7_GnaYcYUGkedmALpbD89jqApTq-s8r?usp=sharing</a></td>
              </tr>
              <tr class="row153">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi  keuangan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1g9w6vmipVG5Vdo6MtS-o4_CjJ8MmlhCZ?usp=sharing" title="">https://drive.google.com/drive/folders/1g9w6vmipVG5Vdo6MtS-o4_CjJ8MmlhCZ?usp=sharing</a></td>
              </tr>
              <tr class="row154">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/17ovGdIyTcYYpYxlAxNkzCcQkeExU3WAM?usp=sharing" title="">https://drive.google.com/drive/folders/17ovGdIyTcYYpYxlAxNkzCcQkeExU3WAM?usp=sharing</a></td>
              </tr>
              <tr class="row155">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi sarana dan prasarana</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://sion.pnb.ac.id/index.php?page=512&amp;language=id" title="">https://sion.pnb.ac.id/index.php?page=512&amp;language=id</a></td>
              </tr>
              <tr class="row156">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1JjQ6fvIKeM-y21sN6tO4IKfXjvho-gFR?usp=sharing" title="">https://drive.google.com/drive/folders/1JjQ6fvIKeM-y21sN6tO4IKfXjvho-gFR?usp=sharing</a></td>
              </tr>
              <tr class="row157">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi sistem informasi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://sion.pnb.ac.id/" title="">https://sion.pnb.ac.id </a></td>
              </tr>
              <tr class="row158">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi sistem penjaminan mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing" title="">https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing </a></td>
              </tr>
              <tr class="row159">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi kerjasama</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1XkegoQs1e2sdm3QhkpvrnygDRjGug50l/view?usp=sharing" title="">https://drive.google.com/file/d/1XkegoQs1e2sdm3QhkpvrnygDRjGug50l/view?usp=sharing </a></td>
              </tr>
              <tr class="row160">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row161">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Renstra PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">2015-2019:</td>
              </tr>
              <tr class="row162">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1umQzdbq8TK-a0Vrkcun0mb2Zio633XC2/view?usp=sharing" title="">https://drive.google.com/file/d/1umQzdbq8TK-a0Vrkcun0mb2Zio633XC2/view?usp=sharing</a></td>
              </tr>
              <tr class="row163">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">2020-2024:</td>
              </tr>
              <tr class="row164">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing" title="">https://drive.google.com/file/d/1GDBLHjOk4y0GCfGemVjWK7GVlZOnEDKX/view?usp=sharing</a></td>
              </tr>
              <tr class="row165">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP Penyusunan Renstra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing" title="">https://drive.google.com/file/d/13mz49tOkfKgE88LtKwXzUMMcO-ddm6YP/view?usp=sharing</a></td>
              </tr>
              <tr class="row166">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPT Tim penyusun Renstra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1YhYzHuQXlMNNI3GbamTpNQ9tXVQf7U0r/view?usp=sharing" title="">https://drive.google.com/file/d/1YhYzHuQXlMNNI3GbamTpNQ9tXVQf7U0r/view?usp=sharing</a></td>
              </tr>
              <tr class="row167">
                <td class="column0 style2 n">7</td>
                <td class="column1 style3 s">C.2.4.d) Sistem Penjaminan Mutu</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row168">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">TKO PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row169">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK Tim SPMI beserta organ / fungsi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/file/d/1yJy7g9FDSu2P38bvS0Q_KipKyYDFeYXr/view?usp=sharing</td>
              </tr>
              <tr class="row170">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">https://drive.google.com/file/d/1OMV1T_m2Dawd1z0cfCE4b_QOncaS4RVn/view?usp=sharing</td>
              </tr>
              <tr class="row171">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK tim auditor internal</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/file/d/14y_jLUXgrfJ2Io1IKl--7wlsUhakYzLM/view?usp=sharing </td>
              </tr>
              <tr class="row172">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Dokumen SPMI</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing" title="">https://drive.google.com/drive/folders/1hz2IdC0ks0-S4YvnzOg080d-DvZnFuxy?usp=sharing </a></td>
              </tr>
              <tr class="row173">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Hasil audit internal</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1cuFPy1M58F_t_ete3nCrjYILaNEZC4x4?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row174">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan tindak lanjut hasil audit</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1eDXCJF4XGnAUvehzLBlsF2L1TgE3WPxX?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1eDXCJF4XGnAUvehzLBlsF2L1TgE3WPxX?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row175">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK penetapan infikator tambahan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/file/d/1GldPg0XTjf8YvVTe8ybuYc3jKVZ1DF0K/view?usp=sharing </td>
              </tr>
              <tr class="row176">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti Penerapan risk based audit</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row177">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row178">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Daftar hadir dan notulensi rapat dengan 7 agenda </td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row179">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row180">
                <td class="column0 style2 n">8</td>
                <td class="column1 style3 s">Tabel 1.a LKPT Sertifikasi / Akreditasi Eksternal</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row181">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Sertifikat akreditasi PT dari lembaga internasional </td>
                <td class="column3 style2 s">X</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row182">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Sertifikat akreditasi prodi dari lembaga internasional </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1g_mKMkqq7CKPvSwufMy-otxc4FaiLH-l/view" title="">https://drive.google.com/file/d/1g_mKMkqq7CKPvSwufMy-otxc4FaiLH-l/view</a></td>
              </tr>
              <tr class="row183">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/15VpFZlJk8UwW1GFTu393IKlgmbnoDKgG/view" title="">https://drive.google.com/file/d/15VpFZlJk8UwW1GFTu393IKlgmbnoDKgG/view</a></td>
              </tr>
              <tr class="row184">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1ku_vBKljHUukSASOUZCaNccajEe3MRwz/view" title="">https://drive.google.com/file/d/1ku_vBKljHUukSASOUZCaNccajEe3MRwz/view</a></td>
              </tr>
              <tr class="row185">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/10Csk_uJna6s9-WT6JJmrX7wp8KQYwvB0/view" title="">https://drive.google.com/file/d/10Csk_uJna6s9-WT6JJmrX7wp8KQYwvB0/view</a></td>
              </tr>
              <tr class="row186">
                <td class="column0 style2 n">9</td>
                <td class="column1 style3 s">Tabel 1.a LKPT Audit Eksternal Keuangan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row187">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan temuan audit eksternal</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1QPAxbj4S4A0B-j-LWGXZu7doCeV5wROw" title="">https://drive.google.com/drive/folders/1QPAxbj4S4A0B-j-LWGXZu7doCeV5wROw</a></td>
              </tr>
              <tr class="row188">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row189">
                <td class="column0 style2 n">10</td>
                <td class="column1 style3 s">Tabel 1.b LKPT Akreditasi Program Studi</td>
                <td class="column2 style3 s">Sertifikat akreditasi prodi dari BAN PT</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row190">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row191">
                <td class="column0 style2 n">11</td>
                <td class="column1 style3 s">C.2.4.d) Kerjasama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row192">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP Pengembangan jejaring dan mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row193">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP monitoring dan evaluasi kepuasan mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row194">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP tersedia di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row195">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Renstra pengembangan jejaring dan mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row196">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">MoU dan PKS dengan seluruh mitra kerjasama</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row197">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan kegiatan kerjasama dengan masing - masing mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row198">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Intrumen survey kepuasan mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row199">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan monev mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row200">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan tindak lanjut hasil survey kepuasan mitra</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row201">
                <td class="column0 style2 n">12</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">MoU dan PKS dengan seluruh mitra kerjasama</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row202">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row203">
                <td class="column0 style2 n">13</td>
                <td class="column1 style3 s">C.2.5 Indikator Kinerja Tambahan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row204">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK penetapan indikator tambahan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row205">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row206">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row207">
                <td class="column0 style2 n">14</td>
                <td class="column1 style3 s">C.2.6 Evaluasi Capaian Kinerja</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row208">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP PNB di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row209">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row210">
                <td class="column0 style2 n">15</td>
                <td class="column1 style3 s">C.2.7 Penjaminan Mutu</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row211">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK penetapan standar mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row212">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti pelaksanaan standar mut usecara konsisten</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row213">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti monev dan pengendalian standar mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row214">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti tindak lanjut hasil monev standar mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row215">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row216">
                <td class="column0 style2 n">16</td>
                <td class="column1 style3 s">C.2.8 Kepuasan Pemangku Kepentingan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row217">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Intrumen survey kepuasan pemangku kepentingan</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row218">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kepuasan pemangku kepentingan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row219">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tindak lanjut hasil survey pemangku kepentingan di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row220">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row221">
                <td class="column0 style2 n">17</td>
                <td class="column1 style3 s">C.3. Mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row222">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.3.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row223">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.3.4.a) Kualitas Input Mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row224">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 2.a LKPT Seleksi Mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row225">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan seleksi penerimaan mahasiswa baru (soal seleksi)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1bP4QXKV4nVl5xnXcnEe9KbIewMvtcL3j" title="">
                    https://drive.google.com/drive/folders/1bP4QXKV4nVl5xnXcnEe9KbIewMvtcL3j
                  </a>
                </td>
              </tr>
              <tr class="row226">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">surat penetapan hasil seleksi mahasiswa baru</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1Carjk0Ws9idmNtX0dbAXma5JtsUGI3vw" title="">https://drive.google.com/drive/folders/1Carjk0Ws9idmNtX0dbAXma5JtsUGI3vw</a></td>
              </tr>
              <tr class="row227">
                <td class="column0 style2 n">18</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan seleksi penerimaan mahasiswa baru</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1YwI5pDnOiQy4_Et9FdXFIpu9rDD46g6b" title="">
                    https://drive.google.com/drive/folders/1YwI5pDnOiQy4_Et9FdXFIpu9rDD46g6b
                  </a>
                </td>
              </tr>
              <tr class="row228">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK mahasiswa baru</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1ner1FcS3mW381UEqJVjjBRC2yhTVaqwH </td>
              </tr>
              <tr class="row229">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row230">
                <td class="column0 style2 n">19</td>
                <td class="column1 style3 s">Tabel 2.b LKPT Mahasiswa Asing</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row231">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan seleksi penerimaan mahasiswa asing</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1rmeCDBPENPyEAMJgmoZvwKIo2OYZAYXC" title="">
                    https://drive.google.com/drive/folders/1rmeCDBPENPyEAMJgmoZvwKIo2OYZAYXC
                  </a>
                </td>
              </tr>
              <tr class="row232">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">surat penetapan hasil seleksi mahasiswa asing</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1aCUDlGrMOqQVoXMtKjhKmgjO_L61tvVN" title="">https://drive.google.com/drive/folders/1aCUDlGrMOqQVoXMtKjhKmgjO_L61tvVN</a></td>
              </tr>
              <tr class="row233">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row234">
                <td class="column0 style2 n">20</td>
                <td class="column1 style3 s">C.3.4.b) Layanan Kemahasiswaan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row235">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan pembinaan dan pengembangan minat dan bakat (laporan kegiatan iUP2KK)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1gme5VBScz6kMErvPrKgZ9dg7Iw6VewkM" title="">
                    https://drive.google.com/drive/folders/1gme5VBScz6kMErvPrKgZ9dg7Iw6VewkM
                  </a><br>
                  <a href="https://bit.ly/36bMoOj" title="">
                    https://bit.ly/36bMoOj
                  </a><br>
                  <a href="https://bit.ly/3JBlgGM" title="">
                    https://bit.ly/3JBlgGM
                  </a>
                </td>
              </tr>
              <tr class="row236">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan peningkatan kesejahteraan (beasiswa, layanan kesehatan)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1zGMGo5uFNHsPRXUxi3n9VMq4SsCiJuta" title="">
                    https://drive.google.com/drive/folders/1zGMGo5uFNHsPRXUxi3n9VMq4SsCiJuta
                  </a><br>
                  <a href="https://drive.google.com/drive/folders/1x2gEHIK2TORSjRCK02jM2Q69HZS0opDD" title="">
                    https://drive.google.com/drive/folders/1x2gEHIK2TORSjRCK02jM2Q69HZS0opDD
                  </a>
                </td>
              </tr>
              <tr class="row237">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan kegiatan penyuluhan karir dan bimbingan kewiraushaan)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1Bdcwpr3QIpR5GQGml8PskGDJ4SOIZ203" title="">
                    https://drive.google.com/drive/folders/1Bdcwpr3QIpR5GQGml8PskGDJ4SOIZ203
                  </a><br>
                  <a href="https://drive.google.com/drive/folders/1wYMo9suVqkNY5rxTjn-7UlRPFKUnpPZg" title="">
                    https://drive.google.com/drive/folders/1wYMo9suVqkNY5rxTjn-7UlRPFKUnpPZg
                  </a>
                </td>
              </tr>
              <tr class="row238">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1wYMo9suVqkNY5rxTjn-7UlRPFKUnpPZg</td>
              </tr>
              <tr class="row239">
                <td class="column0 style2 n">21</td>
                <td class="column1 style3 s">C.4. Sumber Daya Manusia</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row240">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.4.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row241">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.4.4.a) Profil Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row242">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 3.a.1) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row243">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">daftar nama DT di PDD Dikti</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1nbnQuJFWZ9reGxMRRCgBfR8yDheyKdSE?usp=sharing" title="">https://drive.google.com/drive/folders/1nbnQuJFWZ9reGxMRRCgBfR8yDheyKdSE?usp=sharing</a></td>
              </tr>
              <tr class="row244">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row245">
                <td class="column0 style2 n">22</td>
                <td class="column1 style3 s">Tabel 3.a.2) LKPT </td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row246">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Jabatan Fungsional Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row247">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh SK jabatan akademik LK dan GB </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1JBAEQDEFW9Yv5t8GpCLt7tFAHZB8sJeV?usp=sharing</td>
              </tr>
              <tr class="row248">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row249">
                <td class="column0 style2 n">23</td>
                <td class="column1 style3 s">Tabel 3.a.3) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row250">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Sertifikasi dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row251">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh sertifikat kompetensi / profesi (serdos) / industri</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1QE2ioUmcxJai_lTWGMJcHmkFwi3kAMw9?usp=sharing</td>
              </tr>
              <tr class="row252">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row253">
                <td class="column0 style2 n">24</td>
                <td class="column1 style3 s">Tabel 3.a.4) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row254">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Dosen tidak tetap.</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row255">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh SK PNS dosen</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1wyrSFMZwKFA2L9Y-xuMaoYJH25J7_2iq?usp=sharing</td>
              </tr>
              <tr class="row256">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh SK pengangkatan dosen tetap non PNS</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1eh-xsuqT--akMX4YIiZfRx0j5b4is1YW?usp=sharing</td>
              </tr>
              <tr class="row257">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh SK pengangkatan dosen tidak tetap</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1zTmB_jxcQBF1pxcn0U0RwJ3jtWHqlG4r?usp=sharing</td>
              </tr>
              <tr class="row258">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row259">
                <td class="column0 style2 n">25</td>
                <td class="column1 style3 s">Tabel 3.b LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row260">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Beban Kerja Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row261">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">daftar mahasiswa PNB (PDD Dikti)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1fciQixc0ARkZV8xjPzJMlSZvKNzQAp_I?usp=sharing</td>
              </tr>
              <tr class="row262">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row263">
                <td class="column0 style2 n">26</td>
                <td class="column1 style3 s">C.4.4.b) Kinerja Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row264">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 3.c.1) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row265">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Produktivitas Penelitian Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row266">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Surat perjanjian / kontrak pendanaan penelitian</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row267">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan penelitian</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row268">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row269">
                <td class="column0 style2 n">27</td>
                <td class="column1 style3 s">Tabel 3.c.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row270">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Produktivitas PkM Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row271">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Surat perjanjian / kontrak pendanaan PkM</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1Frkp3ucYzOKwdURFaipCEGsbHFERwxHp?usp=sharing</td>
              </tr>
              <tr class="row272">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan PkM</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/18d9OjprTQKdVhoSZuCAQKwNaJGWlv_AT?usp=sharing" title="">
                    https://drive.google.com/drive/folders/18d9OjprTQKdVhoSZuCAQKwNaJGWlv_AT?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row273">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row274">
                <td class="column0 style2 n">28</td>
                <td class="column1 style3 s">Tabel 3.d LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row275">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Rekognisi Dosen</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row276">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat visiting lecturer di PT akreditas iA / unggul atau PT internasional bereputasi</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1D1pUg_CPkGDV9Z5vO8Y0mVZ59uth7NW0?usp=sharing</td>
              </tr>
              <tr class="row277">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat keynote speaker pada pertemuan tingkat nasional / internasional</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1D1pUg_CPkGDV9Z5vO8Y0mVZ59uth7NW0?usp=sharing</td>
              </tr>
              <tr class="row278">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat editor jurnal nasional terakreditasi / jurnal internasional</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1D1pUg_CPkGDV9Z5vO8Y0mVZ59uth7NW0?usp=sharing</td>
              </tr>
              <tr class="row279">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK pengangkatan tenaga ahli / konsultan di lembaga nasional / internasional</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1D1pUg_CPkGDV9Z5vO8Y0mVZ59uth7NW0?usp=sharing</td>
              </tr>
              <tr class="row280">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">piagam penghargaan di tingkat nasional / internasional</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1D1pUg_CPkGDV9Z5vO8Y0mVZ59uth7NW0?usp=sharing</td>
              </tr>
              <tr class="row281">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row282">
                <td class="column0 style2 n">29</td>
                <td class="column1 style3 s">C.4.4.c) Tenaga Kependidikan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row283">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">daftar nama tendik</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1_xBZG0yUqC3LRNyyxaI9Wy92ohrXosMq?usp=sharing</td>
              </tr>
              <tr class="row284">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">ijazah terakhir tendik / surat tugas belajar tendik</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/10JwWeIxHGwoQwF0gtNSlXFox5pcyOwGE?usp=sharing</td>
              </tr>
              <tr class="row285">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat keahlian tendik</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1t4n7uBOSJ_QYGs5vPwOslhK5vpNKHTJE?usp=sharing</td>
              </tr>
              <tr class="row286">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK penempatan tendik di dalam institusi</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/19Ff-HA1tv-ClVTVyqG76c_zPj7NLNJ4Q?usp=sharing</td>
              </tr>
              <tr class="row287">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row288">
                <td class="column0 style2 n">30</td>
                <td class="column1 style3 s">C.5. Keuangan, Sarana dan Prasarana</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row289">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.5.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row290">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.5.4.a) Keuangan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row291">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 4.a LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row292">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Perolehan dana</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row293">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan Keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row294">
                <td class="column0 style2 n">31</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan Keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg
                  </a>
                </td>
              </tr>
              <tr class="row295">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row296">
                <td class="column0 style2 n">32</td>
                <td class="column1 style3 s">Tabel 4.b LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row297">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Penggunaan Dana</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row298">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Laporan Keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg
                  </a>
                </td>
              </tr>
              <tr class="row299">
                <td class="column0 style2 n">33</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharingg
                  </a>
                </td>
              </tr>
              <tr class="row300">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan P3M untuk dana yang masuk di rekening peneliti</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row301">
                <td class="column0 style2 n">34</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row302">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan P3M untuk dana yang masuk di rekening pengabdi</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row303">
                <td class="column0 style2 n">35</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row304">
                <td class="column0 style2 n">36</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1mNCd0Y1u4_GxI-LOgd952z5Xn7srgGnN?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row305">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row306">
                <td class="column0 style2 n">37</td>
                <td class="column1 style3 s">C.5.4.b) Sarana dan Prasarana</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row307">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti Daftar inventaris sarpras</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://docs.google.com/spreadsheets/d/1xIt1wM3oQhZ4mBJFWVs5HHRUI1NtBOEi/edit?usp=sharing&amp;ouid=101688934295731431623&amp;rtpof=true&amp;sd=true" title="">
                    https://docs.google.com/spreadsheets/d/1xIt1wM3oQhZ4mBJFWVs5HHRUI1NtBOEi/edit?usp=sharing&amp;ouid=101688934295731431623&amp;rtpof=true&amp;sd=true
                  </a>
                </td>
              </tr>
              <tr class="row308">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 s">https://docs.google.com/spreadsheets/d/1xIh8KAZgnogIgUVBZMLvZd0NkE-kSjhE/edit?usp=sharing&amp;ouid=101688934295731431623&amp;rtpof=true&amp;sd=true</td>
              </tr>
              <tr class="row309">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Bukti foto/video Sarpras</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/13ykZXTSdq3KAseAYTkpKJOJl7L16y4fM?usp=sharing" title="">https://drive.google.com/drive/folders/13ykZXTSdq3KAseAYTkpKJOJl7L16y4fM?usp=sharing</a></td>
              </tr>
              <tr class="row310">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/13yjca6b89b68K8Cc0aF8i10GzAoJ9dNP?usp=sharing" title="">https://drive.google.com/drive/folders/13yjca6b89b68K8Cc0aF8i10GzAoJ9dNP?usp=sharing</a></td>
              </tr>
              <tr class="row311">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">daftar tautan sistem informasi di lingkup PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://sion.pnb.ac.id/?page=522&amp;language=id" title="">https://sion.pnb.ac.id/?page=522&amp;language=id</a></td>
              </tr>
              <tr class="row312">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://sion.pnb.ac.id/index.php?informasi=0" title="">https://sion.pnb.ac.id/index.php?informasi=0</a></td>
              </tr>
              <tr class="row313">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen survey kepuasan pengguna terhadap sistem informasi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style5 s"><a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing</a></td>
              </tr>
              <tr class="row314">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tahunan hasil survey sistem informasi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">
                    https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row315">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tindak lanjut hasil survey sistem informasi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">
                    https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row316">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">daftar tautan layanan yang dimiliki PNB (e-Learning, e-book, e-journal, e-repository, dll)</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="http://sion.pnb.ac.id/" title="">http://sion.pnb.ac.id</a></td>
              </tr>
              <tr class="row317">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="http://elearning.pnb.ac.id/" title="">http://elearning.pnb.ac.id</a></td>
              </tr>
              <tr class="row318">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="http://perpustakaan.pnb.ac.id/" title="">http://perpustakaan.pnb.ac.id</a></td>
              </tr>
              <tr class="row319">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://ojs.pnb.ac.id/" title="">https://ojs.pnb.ac.id/</a></td>
              </tr>
              <tr class="row320">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://ojs2.pnb.ac.id/" title="">https://ojs2.pnb.ac.id/</a></td>
              </tr>
              <tr class="row321">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="http://simlitabmas.pnb.ac.id/" title="">http://simlitabmas.pnb.ac.id</a></td>
              </tr>
              <tr class="row322">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen survey kepuasan pengguna terhadap sistem informasi layanan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing</a></td>
              </tr>
              <tr class="row323">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tahunan hasil survey sistem informasi layanan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">
                    https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row324">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tindak lanjut hasil survey sistem informasi layanan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing" title="">
                    https://drive.google.com/drive/folders/150yhHevi5uf6cCJg_JgcumAK9rnLAU6D?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row325">
                <td class="column0 style3 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row326">
                <td class="column0 style2 n">38</td>
                <td class="column1 style3 s">C.6. Pendidikan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row327">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.6.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row328">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.6.4.a) Kurikulum</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row329">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">kebijakan pengembangan kurikulum yang mempertimbangkan 4 aspek</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1SVP1HwTPLRYV8Ms2mTBXdYrisRR1n-oi/view" title="">https://drive.google.com/file/d/1SVP1HwTPLRYV8Ms2mTBXdYrisRR1n-oi/view</a></td>
              </tr>
              <tr class="row330">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku pedoman pengembangan kurikulum serta mekanisme penetapan kurikulum</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1_xALxbmYJ4jxGHFAzR9pPjDdwRg2KVwG/view" title="">https://drive.google.com/file/d/1_xALxbmYJ4jxGHFAzR9pPjDdwRg2KVwG/view</a></td>
              </tr>
              <tr class="row331">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku pedoman pelaksanaan kurikulum</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row332">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row333">
                <td class="column0 style2 n">39</td>
                <td class="column1 style3 s">C.6.4.b) Pembelajaran</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row334">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP penugasan dosen pada proses pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row335">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP penetapan isi dan proses pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row336">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP penilaian pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row337">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku pedoman akademik PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row338">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil monev pembelajaran per tahun</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row339">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tindak lanjut hasil monev pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row340">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row341">
                <td class="column0 style2 n">40</td>
                <td class="column1 style3 s">Tabel 2.c LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row342">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Bobot Kredit Mata Kuliah</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row343">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku kurikulum dan struktur kurikulum seluruh program studi yang telah disahkan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row344">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row345">
                <td class="column0 style2 n">41</td>
                <td class="column1 style3 s">C.6.4.c) Integrasi Penelitian dan PkM dalam Pembelajaran</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row346">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumen kebijakan integrasi penelitian dan PkM ke dalam pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row347">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP pelaksanaan integrasi penelitian dan PkM ke dalam pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row348">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP evaluasi integrasi penelitian dan PkM ke dalam pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row349">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman / SOP kendali mutu integrasi penelitian dan PkM ke dalam pembelajaran</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row350">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil monev integrasi penelitian dan PkM pada pembelajaran per tahun</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row351">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan tindak lanjut hasil monev integrasi penelitian dan PkM</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row352">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row353">
                <td class="column0 style2 n">42</td>
                <td class="column1 style3 s">C.6.4.d) Suasana Akademik</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row354">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumen kebijakan suasan akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row355">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan yang mendukung interaksi akademik (forum ilmiah, webinar, studium general, pelatihan internal, dll)</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row356">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen survey kepuasan suasana akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row357">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil survey kepuasan suasana akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row358">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil tindak lanjut hasil survey kepuasan suasana akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row359">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra pengembangan suasana akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row360">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">bukti implementasi renstra pengembangan suasana akademik</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row361">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row362">
                <td class="column0 style2 n">43</td>
                <td class="column1 style3 s">C.7. Penelitian</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row363">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.7.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row364">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.7.4.a) Penelitian</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row365">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra penelitian PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/19KTyxS3DGWxYSOuDq0Ngw7Od8DYzyQo7/view" title="">https://drive.google.com/file/d/19KTyxS3DGWxYSOuDq0Ngw7Od8DYzyQo7/view</a></td>
              </tr>
              <tr class="row366">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">pedoman penelitian PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/16zOSu6OBTmb8ZsZ_KVYVDt1_kf5zJkkn/view" title="">https://drive.google.com/file/d/16zOSu6OBTmb8ZsZ_KVYVDt1_kf5zJkkn/view</a></td>
              </tr>
              <tr class="row367">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan sosialisasi pedoman penelitian</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/file/d/1lhvm45js6FhKkge4wgsDNaIZ8msXSTQj/view?usp=sharing" title="">https://drive.google.com/file/d/1lhvm45js6FhKkge4wgsDNaIZ8msXSTQj/view?usp=sharing</a></td>
              </tr>
              <tr class="row368">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP pelaksanaan penelitian yang memuat 6 aspek</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1q5wI7laXk9xHS2vZmQxlRUq6Z4U2y0XP?usp=sharing" title="">https://drive.google.com/drive/folders/1q5wI7laXk9xHS2vZmQxlRUq6Z4U2y0XP?usp=sharing</a></td>
              </tr>
              <tr class="row369">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan monev penelitian</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/11gpzLK_w93nYynm8rdhfF0t8WET_FXNA?usp=sharing" title="">https://drive.google.com/drive/folders/11gpzLK_w93nYynm8rdhfF0t8WET_FXNA?usp=sharing</a></td>
              </tr>
              <tr class="row370">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumentasi luaran penelitian (jurnal / HKI / prototype, dll)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://docs.google.com/spreadsheets/d/13Q7P2S9DodhOu-3jacDPFfkkhoPvmy2D/edit?usp=sharing&amp;ouid=111043135533838901428&amp;rtpof=true&amp;sd=true" title="">https://docs.google.com/spreadsheets/d/13Q7P2S9DodhOu-3jacDPFfkkhoPvmy2D/edit?usp=sharing&amp;ouid=111043135533838901428&amp;rtpof=true&amp;sd=true</a></td>
              </tr>
              <tr class="row371">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan penelitian tahunan P3M kepada direktur</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1ZTOsjdL7Lon_4pmZr-h9Toxfnw4FbWUj?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1ZTOsjdL7Lon_4pmZr-h9Toxfnw4FbWUj?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row372">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row373">
                <td class="column0 style2 n">44</td>
                <td class="column1 style3 s">C.8. Pengabdian kepada Masyarakat</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row374">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.8.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row375">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.8.4.a) Pelaksanaan PkM</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row376">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">renstra PkM PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/16ho9w8vTdl3IfDixbJdOMGWJ-R1z110Z?usp=sharing" title="">https://drive.google.com/drive/folders/16ho9w8vTdl3IfDixbJdOMGWJ-R1z110Z?usp=sharing</a></td>
              </tr>
              <tr class="row377">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Pedoman PkM PNB</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1HHr97JJoQVEx5ARSbkRUwoH5WNjl3pD-?usp=sharing" title="">https://drive.google.com/drive/folders/1HHr97JJoQVEx5ARSbkRUwoH5WNjl3pD-?usp=sharing</a></td>
              </tr>
              <tr class="row378">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan sosialisasi pedoman PkM</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1btSONh4TVIWSW2g8nA-HN8NxBs2VjGgv?usp=sharing" title="">https://drive.google.com/drive/folders/1btSONh4TVIWSW2g8nA-HN8NxBs2VjGgv?usp=sharing</a></td>
              </tr>
              <tr class="row379">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SOP pelaksanaan PkM yang memuat 6 aspek</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1aF7Vv8-xVPrnQ83XkFOY6LkzwareZmxk?usp=sharing" title="">https://drive.google.com/drive/folders/1aF7Vv8-xVPrnQ83XkFOY6LkzwareZmxk?usp=sharing</a></td>
              </tr>
              <tr class="row380">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan monev PkM</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1-g-kbilJ0753NzHSQO6KRecnwWQVH0qe?usp=sharing" title="">https://drive.google.com/drive/folders/1-g-kbilJ0753NzHSQO6KRecnwWQVH0qe?usp=sharing</a></td>
              </tr>
              <tr class="row381">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumentasi luaran PkM (jurnal / HKI / prototype, dll)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/121Enf_SqCKFvqxcg3jodJ0hpLUVJZFtH?usp=sharing" title="">https://drive.google.com/drive/folders/121Enf_SqCKFvqxcg3jodJ0hpLUVJZFtH?usp=sharing</a></td>
              </tr>
              <tr class="row382">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan PkM tahunan P3M kepada direktur</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1dfemB0G14zMSdQ8kU8K3IE4NTnBSTUq_?usp=sharing" title="">
                    https://drive.google.com/drive/folders/1dfemB0G14zMSdQ8kU8K3IE4NTnBSTUq_?usp=sharing
                  </a>
                </td>
              </tr>
              <tr class="row383">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row384">
                <td class="column0 style2 n">45</td>
                <td class="column1 style3 s">C.8.4.b) Kelompok Pelaksana PkM</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row385">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK / surat tugas kelompok pelaksana PkM</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://drive.google.com/drive/folders/1v40Fhdpjob-m7kdJGQeg-gVVM7yS6ROV?usp=sharing</td>
              </tr>
              <tr class="row386">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan PkM oleh kelompok pelaksana </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://drive.google.com/drive/folders/1v40Fhdpjob-m7kdJGQeg-gVVM7yS6ROV?usp=sharingg" title="">
                    https://drive.google.com/drive/folders/1v40Fhdpjob-m7kdJGQeg-gVVM7yS6ROV?usp=sharingg
                  </a>
                </td>
              </tr>
              <tr class="row387">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumentasi produk PkM yang bermanfaat dan berdaya saing nasional</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://drive.google.com/drive/folders/1v40Fhdpjob-m7kdJGQeg-gVVM7yS6ROV?usp=sharing" title="">https://drive.google.com/drive/folders/1v40Fhdpjob-m7kdJGQeg-gVVM7yS6ROV?usp=sharing</a></td>
              </tr>
              <tr class="row388">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row389">
                <td class="column0 style2 n">46</td>
                <td class="column1 style3 s">C.9. Luaran dan Capaian Tridharma</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row390">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.9.4. Indikator Kinerja Utama</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row391">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">C.9.4.a) Pendidikan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row392">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 5.a LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row393">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Capaian Pembelajaran</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row394">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku wisuda</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3IuQwWY" title="">https://bit.ly/3IuQwWY</a></td>
              </tr>
              <tr class="row395">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">SK penetapan hasil yudisium</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://bit.ly/3IuQwWY</td>
              </tr>
              <tr class="row396">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row397">
                <td class="column0 style2 n">47</td>
                <td class="column1 style3 s">Tabel 5.a.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row398">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Sertifikat Kompetensi / Profesi / Industri</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row399">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">seluruh sertifikat kompetensi / profesi  / industri yang dimiliki lulusan</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://bit.ly/3PnoPnE</td>
              </tr>
              <tr class="row400">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row401">
                <td class="column0 style2 n">48</td>
                <td class="column1 style3 s">Tabel 5.b.1) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row402">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Prestasi akademik mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row403">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">piagam penghargaan prestasi akademik</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://bit.ly/36bMoOj</td>
              </tr>
              <tr class="row404">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row405">
                <td class="column0 style2 n">49</td>
                <td class="column1 style3 s">Tabel 5.b.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row406">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Prestasi non-akademik mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row407">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">piagam penghargaan prestasi non - akademik</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">https://bit.ly/3JBlgGM</td>
              </tr>
              <tr class="row408">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row409">
                <td class="column0 style2 n">50</td>
                <td class="column1 style3 s">Tabel 5.c.1) LKPT </td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row410">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Lama studi mahasiswa</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row411">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3l7GUYP" title="">https://bit.ly/3l7GUYP</a></td>
              </tr>
              <tr class="row412">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil penelusuran tamatan (tracer study) - dibagikan kepada lulusan yg telah lulus minimal 2 tahun</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3Oab4XV" title="">https://bit.ly/3Oab4XV</a></td>
              </tr>
              <tr class="row413">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row414">
                <td class="column0 style2 n">51</td>
                <td class="column1 style3 s">Tabel 5.c.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row415">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3l7GUYP" title="">https://bit.ly/3l7GUYP</a></td>
              </tr>
              <tr class="row416">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3Oab4XV" title="">https://bit.ly/3Oab4XV</a></td>
              </tr>
              <tr class="row417">
                <td class="column0 style2 n">52</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3l7GUYP" title="">https://bit.ly/3l7GUYP</a></td>
              </tr>
              <tr class="row418">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3Oab4XV" title="">https://bit.ly/3Oab4XV</a></td>
              </tr>
              <tr class="row419">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row420">
                <td class="column0 style2 n">53</td>
                <td class="column1 style3 s">Tabel 5.d.1) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row421">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Waktu tunggu lulusan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row422">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3l7GUYP" title="">https://bit.ly/3l7GUYP</a></td>
              </tr>
              <tr class="row423">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3Oab4XV" title="">https://bit.ly/3Oab4XV</a></td>
              </tr>
              <tr class="row424">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row425">
                <td class="column0 style2 n">54</td>
                <td class="column1 style3 s">Tabel 5.d.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row426">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Kesesuaian bidang kerja lulusan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row427">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3l7GUYP" title="">https://bit.ly/3l7GUYP</a></td>
              </tr>
              <tr class="row428">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil penelusuran tamatan (tracer study) </td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3Oab4XV" title="">https://bit.ly/3Oab4XV</a></td>
              </tr>
              <tr class="row429">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row430">
                <td class="column0 style2 n">55</td>
                <td class="column1 style3 s">Tabel 5.e.1) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row431">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Kepuasan Pengguna Lulusan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row432">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen survey kepuasan pengguna lulusan (mitra) yang menilai 7 aspek</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://forms.gle/MvPhgEuD3ZYTnx2w8" title="">https://forms.gle/MvPhgEuD3ZYTnx2w8</a></td>
              </tr>
              <tr class="row433">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil survey kepuasan pengguna lulusan (mitra)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3HmDhsr" title="">https://bit.ly/3HmDhsr</a></td>
              </tr>
              <tr class="row434">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row435">
                <td class="column0 style2 n">56</td>
                <td class="column1 style3 s">Tabel 5.e.2) LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row436">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tempat kerja lulusan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row437">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">instrumen survey kepuasan pengguna lulusan (mitra)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://forms.gle/MvPhgEuD3ZYTnx2w8" title="">https://forms.gle/MvPhgEuD3ZYTnx2w8</a></td>
              </tr>
              <tr class="row438">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil survey kepuasan pengguna lulusan (mitra)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3HmDhsr" title="">https://bit.ly/3HmDhsr</a></td>
              </tr>
              <tr class="row439">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row440">
                <td class="column0 style2 n">57</td>
                <td class="column1 style3 s">C.9.4.b) Penelitian</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row441">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Tabel 5.f LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row442">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Publikasi Ilmiah</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row443">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan penelitian dan PkM tahunan P3M kepada direktur</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://bit.ly/3NfAumC" title="">
                    https://bit.ly/3NfAumC
                  </a>
                </td>
              </tr>
              <tr class="row444">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumentasi luaran penelitian (jurnal / HKI / prototype, dll)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3sAbXk5" title="">https://bit.ly/3sAbXk5</a></td>
              </tr>
              <tr class="row445">
                <td class="column0 style2 n">58</td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan penelitian dan PkM tahunan P3M kepada direktur</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://bit.ly/3NfAumC" title="">
                    https://bit.ly/3NfAumC
                  </a>
                </td>
              </tr>
              <tr class="row446">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">dokumentasi luaran seminar / tulisan di media massa</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3sAbXk5" title="">https://bit.ly/3sAbXk5</a></td>
              </tr>
              <tr class="row447">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row448">
                <td class="column0 style2 n">59</td>
                <td class="column1 style3 s">Tabel 5.g LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row449">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Produk/jasa yang diadopsi oleh industri / masyarakat</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row450">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan penelitian dan PkM tahunan P3M kepada direktur</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s"></td>
                <td class="column5 style3 s">
                  <a href="https://bit.ly/3NfAumC" title="">
                    https://bit.ly/3NfAumC
                  </a>
                </td>
              </tr>
              <tr class="row451">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LPJ kegiatan serah terima produk / jasa kepada industri / masyarakat</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 s">Disable</td>
                <td class="column5 style3 s">
                  <a href="https://bit.ly/3synmAW" title="">
                    https://bit.ly/3synmAW
                  </a>
                </td>
              </tr>
              <tr class="row452">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row453">
                <td class="column0 style2 n">60</td>
                <td class="column1 style3 s">Tabel 5.h LKPT</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row454">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">Luaran lainnya</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row455">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat paten</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3w9cgEx" title="">https://bit.ly/3w9cgEx</a></td>
              </tr>
              <tr class="row456">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat hak cipta</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3w9JKTg" title="">https://bit.ly/3w9JKTg</a></td>
              </tr>
              <tr class="row457">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">sertifikat standarisasi produk / sertifikat produk</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/3PjebhG" title="">https://bit.ly/3PjebhG</a></td>
              </tr>
              <tr class="row458">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">buku ISBN (judul, daftar isi, kata pengantar)</td>
                <td class="column3 style2 s">V</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style4 s"><a href="https://bit.ly/39ipJ4e" title="">https://bit.ly/39ipJ4e</a></td>
              </tr>
              <tr class="row459">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row460">
                <td class="column0 style2 n">61</td>
                <td class="column1 style3 s">D  Analisis dan Penetapan Program Pengembangan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row461">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 s">D.1 Analisis dan Capaian Kinerja</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style3 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row462">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan analisis dan capaian kinerja </td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row463">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">LAKIP PT tersedia di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row464">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan keuangan diunggah di website</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row465">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row466">
                <td class="column0 style2 n">62</td>
                <td class="column1 style3 s">D.2 Analisis SWOT atau Analisis Lain yang Relevan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row467">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">laporan hasil analisis SWOT</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row468">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana Pengembangan Institusi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row469">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">RAK PNB</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row470">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row471">
                <td class="column0 style2 n">63</td>
                <td class="column1 style3 s">D.3 Program Pengembangan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row472">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana kebutuhan PNB di masa depan</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row473">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana Pengembangan Institusi</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row474">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row475">
                <td class="column0 style2 n">64</td>
                <td class="column1 style3 s">D.4 Program Keberlanjutan</td>
                <td class="column2 style3 null"></td>
                <td class="column3 style2 null"></td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row476">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana alokasi sumber daya manusia , sarana dan prasarana serta dana</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row477">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Rencana penjaminan mutu berkelanjutan </td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
              <tr class="row478">
                <td class="column0 style2 null"></td>
                <td class="column1 style3 null"></td>
                <td class="column2 style3 s">Buku standar mutu</td>
                <td class="column3 style2 s">─</td>
                <td class="column4 style3 null"></td>
                <td class="column5 style3 null"></td>
              </tr>
            </tbody>
        </table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Data',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-alumni.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    updateLanguage() {
      // this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pengabdian';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html { font-family:Calibri, Arial, Helvetica, sans-serif; font-size:11pt; background-color:white }
  a.comment-indicator:hover + div.comment { background:#ffd; position:absolute; display:block; border:1px solid black; padding:0.5em }
  a.comment-indicator { background:red; display:inline-block; border:1px solid black; width:0.5em; height:0.5em }
  div.comment { display:none }
  table { border-collapse:collapse; page-break-after:always }
  .gridlines td { border:1px dotted black; padding: 5px; }
  .gridlines th { border:1px dotted black }
  .b { text-align:center }
  .e { text-align:center }
  .f { text-align:right }
  .inlineStr { text-align:left }
  .n { text-align:right }
  .s { text-align:left }
  td.style0 { vertical-align:bottom; border-bottom:none #000000; border-top:none #000000; border-left:none #000000; border-right:none #000000; color:#000000; font-family:'Calibri'; font-size:11pt; background-color:white }
  th.style0 { vertical-align:bottom; border-bottom:none #000000; border-top:none #000000; border-left:none #000000; border-right:none #000000; color:#000000; font-family:'Calibri'; font-size:11pt; background-color:white }
  td.style1 { vertical-align:bottom; text-align:center; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; font-weight:bold; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style1 { vertical-align:bottom; text-align:center; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; font-weight:bold; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  td.style2 { vertical-align:bottom; text-align:center; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style2 { vertical-align:bottom; text-align:center; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  td.style3 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style3 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  td.style4 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; text-decoration:underline; color:#0563C1; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style4 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; text-decoration:underline; color:#0563C1; font-family:'Calibri'; font-size:10pt; background-color:white }
  td.style5 { vertical-align:middle; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; text-decoration:underline; color:#0563C1; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style5 { vertical-align:middle; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; text-decoration:underline; color:#0563C1; font-family:'Calibri'; font-size:10pt; background-color:white }
  td.style6 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  th.style6 { vertical-align:bottom; border-bottom:1px solid #000000 !important; border-top:1px solid #000000 !important; border-left:1px solid #000000 !important; border-right:1px solid #000000 !important; color:#000000; font-family:'Calibri'; font-size:10pt; background-color:white }
  table.sheet0 col.col0 { width:15.58888871pt }
  table.sheet0 col.col1 { width:227.73333072pt }
  table.sheet0 col.col2 { width:441.91110604pt }
  table.sheet0 col.col3 { width:27.78888857pt }
  table.sheet0 col.col4 { width:252.13333044pt }
  table.sheet0 col.col5 { width:605.25554861pt }
  table.sheet0 tr { height:15pt }
</style>
